import { render, staticRenderFns } from "./SelecaoEmpresa.vue?vue&type=template&id=108ac348&scoped=true"
import script from "./SelecaoEmpresa.vue?vue&type=script&lang=js"
export * from "./SelecaoEmpresa.vue?vue&type=script&lang=js"
import style0 from "./SelecaoEmpresa.vue?vue&type=style&index=0&id=108ac348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108ac348",
  null
  
)

export default component.exports